module.exports = __webpack_public_path__ + "img/디펜더.7fe9edbd.png";